



























import { Component, Vue, Prop } from 'vue-property-decorator'
import Axios from 'axios'

@Component({
  components: {
    SpotifyAuth: require('@/components/SpotifyAuth').default
  }
})
export default class PlaylistSaveModal extends Vue {
  @Prop({
    default: ''
  })
  playlistName: string

  @Prop({
    default: () => []
  })
  trackIds: string[]

  @Prop()
  disabled: boolean

  loading: boolean = false
  modalOpen: boolean = false
  playlistNameModel: string = this.playlistName

  async open(reAuthenticate: boolean = false) {
    if (this.disabled || this.$store.state.auth.isDemoUser) return

    this.$emit('open')

    await (this.$refs as any).spotifyAuth.waitForAuth(reAuthenticate)

    this.playlistNameModel = this.playlistName

    this.modalOpen = true
  }

  close() {
    this.modalOpen = false
  }

  async save() {
    if (this.loading || this.disabled) return

    this.loading = true

    try {
      await Axios({
        method: 'POST',
        url: '/spotify/save-playlist',
        data: {
          name: this.playlistNameModel,
          trackIds: this.trackIds
        },
        noErrorPopup: true
      } as any)

      this.$buefy.notification.open('Saved to Spotify playlist: ' + this.playlistNameModel)

      this.$emit('save')
    } catch (error) {
      console.error(error)

      if (error.request && error.request.status === 417) {
        setTimeout(async () => {
          await this.$store.dispatch('auth/fetchUserProps')

          this.open(true).catch(err => console.log(err))
        }, 500)
      }

      if (this.$store.state.auth.isDemoUser) {
        this.$buefy.notification.open(`Saved to Spotify playlist: ${this.playlistNameModel}`)
      }
    }

    this.loading = false

    this.close()
  }
}
